import { MyProfileForm } from "../../components";

export default function MyProfilePage() {
  return (
    <div>
      <MyProfileForm />
    </div>
  );
}
